// extracted by mini-css-extract-plugin
export default {"varBoldFontWeight":"var(--tkww-union-typography-bold-font-weight, 500)","pinText":"pinText--e46c6 body2--f71c1"};